import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { EmptyState } from '@/components/states';

export function NotFoundPage() {
  return (
    <EmptyState
      icon={<Compass aria-hidden="true" className="h-8 w-8" />}
      title="Page not found"
      description="That URL does not match anything in the dashboard."
      action={
        <Button asChild variant="outline">
          <Link to="/">Back to the catalogue</Link>
        </Button>
      }
      className="mt-12"
    />
  );
}
